import { jsx } from 'react/jsx-runtime';
import MuiCheckbox from '@mui/material/Checkbox';
import styled from '@emotion/styled';
import { ReactComponent as ForwardRef$3 } from '../../../../assets/icons/SelectAllSemiCheckboxSmall.svg.js';
import { ReactComponent as ForwardRef } from '../../../../assets/icons/SelectAllCheckboxSmall.svg.js';
import { ReactComponent as ForwardRef$2 } from '../../../../assets/icons/FullCheckboxSmall.svg.js';
import { ReactComponent as ForwardRef$1 } from '../../../../assets/icons/CheckboxSmall.svg.js';

const CheckboxContainer = styled('div') `
  margin-right: 4px;
`;
const Checkbox = ({ id, checked, indeterminate, onChange, hasChildren, disabled }) => {
    return (jsx(CheckboxContainer, { children: jsx(MuiCheckbox, { "data-testid": `${id}-checkbox`, checked: checked, disabled: disabled, indeterminate: indeterminate, onChange: e => onChange(e.target.checked), icon: hasChildren ? jsx(ForwardRef, {}) : jsx(ForwardRef$1, {}), checkedIcon: jsx(ForwardRef$2, {}), indeterminateIcon: jsx(ForwardRef$3, {}), inputProps: {
                style: { opacity: 0 },
            } }) }));
};

export { Checkbox };
//# sourceMappingURL=Checkbox.js.map
